import { render, staticRenderFns } from "./LabCulture.vue?vue&type=template&id=4743c744&scoped=true&"
import script from "./LabCulture.vue?vue&type=script&lang=ts&"
export * from "./LabCulture.vue?vue&type=script&lang=ts&"
import style0 from "./LabCulture.vue?vue&type=style&index=0&id=4743c744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4743c744",
  null
  
)

export default component.exports